import { cn } from '@/lib/utils'
import { TONES, halftoneLayers, type ListingTone } from './tones'

interface HalftoneCoverProps {
  tone: ListingTone
  /** Direction the coarse halftone dots grow toward, in degrees. */
  angle?: number
  /** CSS aspect ratio, e.g. "4.39 / 5.88" or "4 / 3". */
  aspect: string
  /** Content laid over the dot field (monogram, document mock-up...). */
  children?: React.ReactNode
  className?: string
}

/**
 * Generated cover art for listing cards: a solid brand tone with a halftone
 * dot field. The fill layer carries `.listing-cover-art` so a parent card can
 * scale it on hover while the frame stays put. Decorative only.
 */
export function HalftoneCover({ tone, angle = 135, aspect, children, className }: HalftoneCoverProps) {
  const spec = TONES[tone]
  const [fine, coarse] = halftoneLayers(spec.dot, angle)
  return (
    <div
      aria-hidden
      className={cn('relative overflow-hidden dark:outline dark:outline-1 dark:-outline-offset-1 dark:outline-white/10', className)}
      style={{ aspectRatio: aspect, color: spec.fg }}
    >
      <div
        className="listing-cover-art absolute inset-0 transition-transform duration-[600ms] ease-[cubic-bezier(0.22,1,0.36,1)] motion-reduce:transition-none"
        style={{ backgroundColor: spec.bg }}
      >
        <div className="absolute inset-0" style={fine} />
        <div className="absolute inset-0" style={coarse} />
        {children && (
          <div className="absolute inset-0 flex items-center justify-center p-[8%]">{children}</div>
        )}
      </div>
    </div>
  )
}
